import {
  Box,
  Button,
  Modal,
  } from "@mui/material";
import React, { useState } from "react";

import { showCustomToast } from "./Misc/CustomToast";
import {
  collection,
  doc,
  getDocs,
  onSnapshot,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { incrementDailyReads } from "../logsComponents/incrementDailyReads";
import { useAuth } from "../contexts/AuthContext";
import { useEffect } from "react";
import UploaderPreAdmission from "./Updloader/UploaderPreAdmission";

import UploaderAraEncapsulated from "./Updloader/UploaderAraEncapsulated";
import AdmissionInformation from "./PreAdmissionComponents/AdmissionInformation";
import AdmissionAdditionalInfo from "./PreAdmissionComponents/AdmissionAdditionalInfo";
import AdmissionAddictions from "./PreAdmissionComponents/AdmissionAddictions";
import AdmissionMentalHealth from "./PreAdmissionComponents/AdmissionMentalHealth";
import AdmissionMedicalInfo from "./PreAdmissionComponents/AdmissionMedicalInfo";
import AdmissionEatingDisorder from "./PreAdmissionComponents/AdmissionEatingDisorder";
import AdmissionAssessorRedFlags from "./PreAdmissionComponents/AdmissionAssessorRedFlags";
import AdmissionAssessorNotice from "./PreAdmissionComponents/AdmissionAssessorNotice";
import AdmissionAssessmentOutcome from "./PreAdmissionComponents/AdmissionAssessmentOutcome";
import AdmissionLegal from "./PreAdmissionComponents/AdmissionLegal";
import AdmissionWrapUp from "./PreAdmissionComponents/AdmissionWrapUp";

import LineLogs from "./Lines/LineLogs";
import StandardDrawer, { StandardDrawerFooter, StandardDrawerHeader } from "./forms/StandardDrawer";
import "./PreAdmission.css";

function PreAdmission(props) {
  const styleModalUploadPdf = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    height: "auto",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const { currentUser } = useAuth();
  const [isModified, setIsModified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [, setIsLoadingFetchLogs] = useState(false);
  const [docData, setDocData] = useState({});
  const [docDataClient, setDocDataClient] = useState({});
  const [openUploadPreAdmission, setOpenUploadPreAdmission] = useState(false);
  const handleClosePreAdmForm = () => setOpenUploadPreAdmission(false);
  const [durationOfStay, setDurationOfStay] = useState(
    props.durationOfStay || ""
  );
  const requiresDurationOfStay =
    props.rehabId !== "miracles_asia_philippines" &&
    props.rehabCountry !== "Philippines" &&
    docDataClient?.rehabId !== "miracles_asia_philippines" &&
    docDataClient?.rehabCountry !== "Philippines";

  const [logs, setLogs] = useState([]);
  const [isModalLogsOpen, setIsModalLogsOpen] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const closeDetailLogsModal = () => setIsDetailsModalOpen(false);
  const closeLogsModal = () => setIsModalLogsOpen(false);

  const showLogDetails = (selectedLog) => {
    const changes = selectedLog.changes;
    const who = selectedLog.recordedBy;
    const when = formatDateLogs(selectedLog.recordedAt);

    return (
      <div className="pre-admission-detail-content">
        <div className="pre-admission-detail-summary">
          <span>Recorded by</span>
          <strong>{who}</strong>
          <time>{when}</time>
        </div>
        <div className="pre-admission-change-list">
          {Object.entries(changes)
            .filter(([key, _]) => key !== "recordedAt")
            .map(([key, value]) => (
              <article className="pre-admission-change-card" key={key}>
                <div className="pre-admission-change-field">{key}</div>
                <div className="pre-admission-change-label">New value</div>
                <div className="pre-admission-change-value">
                  {typeof value === "string"
                    ? value
                    : JSON.stringify(value, null, 2)}
                </div>
              </article>
            ))}
        </div>
      </div>
    );
  };

  function formatDate2(value) {
    if (value && value.toDate) {
      return value.toDate().toLocaleString("en-EN", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    }
    return value;
  }

  const handleShowDetailsClick = (selectedLog) => {
    const sortedLogs = logs.sort(
      (a, b) => b.recordedAt.toDate() - a.recordedAt.toDate()
    );

    const selectedIndex = sortedLogs.findIndex(
      (log) => log.id === selectedLog.id
    );

    if (selectedIndex === -1) {
      setSelectedLog({ ...selectedLog, changes: selectedLog.changes });
    } else {
      const previousLog = sortedLogs[selectedIndex + 1];

      let differences = {};
      Object.keys(selectedLog.changes).forEach((key) => {
        let currentValue = selectedLog.changes[key];
        const previousValue = previousLog
          ? previousLog.changes[key]
          : undefined;

        currentValue = formatDate2(currentValue);
        if (
          (!previousLog ||
            JSON.stringify(currentValue) !== JSON.stringify(previousValue)) &&
          currentValue !== undefined &&
          currentValue !== null &&
          currentValue !== ""
        ) {
          differences[key] = currentValue;
        }
      });

      setSelectedLog({ ...selectedLog, changes: differences });
    }

    setIsDetailsModalOpen(true);
  };

  const fetchLogs = async (clientId) => {
    setIsLoadingFetchLogs(true);
    try {
      const querySnapshot = await getDocs(
        collection(db, "logs", clientId, "modifications")
      );
      const fetchedLogs = [];
      querySnapshot.forEach((doc) => {
        fetchedLogs.push({ id: doc.id, ...doc.data() });
      });
      setLogs(fetchedLogs);
      try {
        incrementDailyReads("profile_preadmission_logs", querySnapshot.size);
      } catch {}
    } catch (error) {
      console.error("Error fetching logs: ", error);
    } finally {
      setIsLoadingFetchLogs(false);
    }
  };

  const openModalLogs = (clientId) => {
    fetchLogs(clientId);
    setIsModalLogsOpen(true);
  };

  const formatDateLogs = (timestamp) => {
    const date = timestamp.toDate();
    return date.toLocaleString();
  };

  const handleDurationOfStayChange = (value) => {
    setIsModified(true);
    setDurationOfStay(value);
  };

  useEffect(() => {
    const docRef = doc(db, "preAdmissionAssessments", props.clientId);
    const unsubscribe = onSnapshot(docRef, (doc) => {
      if (doc.exists()) {
        setDocData(doc.data());
        try {
          incrementDailyReads("profile_preadmission_doc", 1);
        } catch {}
      } else {
        console.log("No such document!");
      }
    });

    return () => unsubscribe();
  }, [props.clientId]);

  useEffect(() => {
    const docRef = doc(db, "clients", props.clientId);
    const unsubscribe = onSnapshot(docRef, (doc) => {
      if (doc.exists()) {
        setDocDataClient(doc.data());
        try {
          incrementDailyReads("profile_client_doc", 1);
        } catch {}
      } else {
        console.log("No such document!");
      }
    });

    return () => unsubscribe();
  }, [props.clientId]);

  useEffect(() => {
    setNationality(docData.nationality || docDataClient.nationality || "");
    setMaritalStatus(
      docData.maritalStatus || docDataClient.maritalStatus || ""
    );
    setPrimaryAddiction(
      docData.primaryAddiction || docDataClient.primaryAddiction || ""
    );
    setAddictionOther(docData.addictionOther || "");
    setPassportStatus(docData.passportStatus || "");
    setCurrentPartner(docData.currentPartner || "");
    setSuicidalThoughtsWhen(docData.suicidalThoughtsWhen || "");
    setSuicidalThoughtsIntent(docData.suicidalThoughtsIntent || "");
    setSuicidePlan(docData.suicidePlan || "");
    setSuicideAttemptsWhen(docData.suicideAttemptsWhen || "");
    setBodyHeight(docData.bodyHeight || "");
    setAddictionOther(docData.addictionOther || "");
    setCurrentLivingArrangements(docData.currentLivingArrangements || "");
    setDietaryRequirements(docData.dietaryRequirements || "");
    setFundingSource(docData.fundingSource || "");
    setCurrentWithdrawalSymptoms(docData.currentWithdrawalSymptoms || "");
    setProcessAddictions(docData.processAddictions || "");
    setAddictionTreatmentHistory(docData.addictionTreatmentHistory || "");
    setTreatmentGoals(docData.treatmentGoals || "");
    setBarriersForRehab(docData.barriersForRehab || "");
    setMotivationForTreatment(docData.motivationForTreatment || "");
    setCurrentMentalHealthIssues(docData.currentMentalHealthIssues || "");
    setLastSelfHarm(docData.lastSelfHarm || "");
    setTraumaHistory(docData.traumaHistory || "");
    setCurrentProvider(docData.currentProvider || "");
    setHistoryOfSeizures(docData.historyOfSeizures || "");
    setCurrentMedications(docData.currentMedications || "");
    setCurrentPastInjury(docData.currentPastInjury || "");
    setCurrentMedicalIllness(docData.currentMedicalIllness || "");
    setAllergies(docData.allergies || "");
    setLegalProblems(docData.legalProblems || "");
    setTherapistPreference(docData.therapistPreference || "");
    setDiscoverMiraclesAsia(docData.discoverMiraclesAsia || "");
    setNeedsNonSmokingRoom(docData.needsNonSmokingRoom || "");
    setEatingDisorderDiagnosis(docData.eatingDisorderDiagnosis || "");
    setEatingDisorderFoodConsumption(
      docData.eatingDisorderFoodConsumption || ""
    );
    setEatingDisorderVomitingLaxatives(
      docData.eatingDisorderVomitingLaxatives || ""
    );
    setTraumaTreatment(docData.traumaTreatment || "");
    setMentalHealthTreatment(docData.mentalHealthTreatment || "");
    setSelfHarmType(docData.selfHarmType || "");
    setUnwantedConsequencesOfAddiction(
      docData.unwantedConsequencesOfAddiction || ""
    );
    setReasonForSeekingTreatment(docData.reasonForSeekingTreatment || "");
    setSubstanceAddiction(docData.substanceAddiction || "");
    setChildrenOrDependents(docData.childrenOrDependents || "");

    // Pour les Checkbox
    setMentalHealthDiagnosis(docData.mentalHealthDiagnosis || false);
    setAnxiety(docData.anxiety || false);
    setDepression(docData.depression || false);
    setPtsd(docData.ptsd || false);
    setPersonalityDisorder(docData.personalityDisorder || false);
    setSchizophrenia(docData.schizophrenia || false);
    setSchizoaffectiveDisorder(docData.schizoaffectiveDisorder || false);
    setBipolar(docData.bipolar || false);
    setBipolarWithPsychoticFeatures(
      docData.bipolarWithPsychoticFeatures || false
    );
    setPreviousPersonalityDisorder(
      docData.previousPersonalityDisorder || false
    );
    setActivePsychosis(docData.activePsychosis || false);
    setDiagnosisWithPsychoticFeatures(
      docData.diagnosisWithPsychoticFeatures || false
    );
    setRecentSelfHarm(docData.recentSelfHarm || false);
    setViolentBehavior(docData.violentBehavior || false);
    setHistoryOfSeizure(docData.historyOfSeizure || false);
    setActiveFoodRestriction(docData.activeFoodRestriction || false);
    setCurrentMobilityIssues(docData.currentMobilityIssues || false);
    setCurrentComplexMedicalIssues(
      docData.currentComplexMedicalIssues || false
    );
    setHistoryOfSuicideAttempts(docData.historyOfSuicideAttempts || false);
    setSuicidalThoughts(docData.suicidalThoughts || false);
    setHallucinations(docData.hallucinations || false);
    setDelusionalThinking(docData.delusionalThinking || false);
    setHallucinationsExplain(docData.hallucinationsExplain || "");
    setDelusionalThinkingExplain(docData.delusionalThinkingExplain || "");
    setNoneApply(docData.noneApply || false);
    setAdhd(docData.adhd || "");
    setPassportCopy(docData.passportCopy || "");
    setFlightDetails(docData.flightDetails || "");
    setVipTransfer(docData.vipTransfer || "");
    setPaymentDetails(docData.paymentDetails || "");
    setHowLongUsingDrink(docData.howLongUsingDrink || "");
    setMentalHealthOtherCheck(docData.mentalHealthOtherCheck || false);
    setMentalHealthOtherContent(docData.mentalHealthOtherContent || "");
    setFlightDetailsContent(docData.flightDetailsContent || "");
    setSecondaryAddiction(docData.secondaryAddiction || "");
    setSecondaryAddictionOther(docData.secondaryAddictionOther || "");
    setEta(docDataClient.eta || "");
    setSuicidalIdeation(docData.suicidalIdeation || false);
    setSuicideAttempt(docData.suicideAttempt || false);
    setHistoryPhysicalViolent(docData.historyPhysicalViolent || "");
    setAssessmentStatus(docData.assessmentStatus || "");
    setAssessmentReason(docData.assessmentReason || "");
    setPreviousClientIdentifier(docData.previousClientIdentifier || "");
    setSpecificDisorder(docData.specificDisorder || "");
    setBipolar12(docData.bipolar12 || false);
    setDurationOfStay(docDataClient.durationOfStay || "");
    setClientUnderstand(docData.clientUnderstand || "");
  }, [docData, docDataClient]);

  // Pour les DropDownComponent

  const [specificDisorder, setSpecificDisorder] = useState("");
  const [flightDetailsContent, setFlightDetailsContent] = useState(
    docData.flightDetailsContent || ""
  );
  const [mentalHealthOtherCheck, setMentalHealthOtherCheck] = useState(
    docData.mentalHealthOtherCheck || ""
  );
  const [mentalHealthOtherContent, setMentalHealthOtherContent] = useState(
    docData.mentalHealthOtherContent || ""
  );
  const [howLongUsingDrink, setHowLongUsingDrink] = useState(
    docData.howLongUsingDrink || ""
  );
  const [nationality, setNationality] = useState(
    docData.nationality || docDataClient.nationality || ""
  );
  const [adhd, setAdhd] = useState(docData.adhd || "");
  const [noneApply, setNoneApply] = useState(docData.noneApply || "");
  const [addictionOther, setAddictionOther] = useState(
    docData.addictionOther || ""
  );
  const [secondaryAddictionOther, setSecondaryAddictionOther] = useState(
    docData.secondartAddictionOther || ""
  );
  const [maritalStatus, setMaritalStatus] = useState(
    docData.maritalStatus || ""
  );
  const [passportCopy, setPassportCopy] = useState(docData.passportCopy || "");
  const [primaryAddiction, setPrimaryAddiction] = useState(
    docData.primaryAddiction || ""
  );
  const [secondaryAddiction, setSecondaryAddiction] = useState(
    docData.secondaryAddiction || ""
  );
  const [needsNonSmokingRoom, setNeedsNonSmokingRoom] = useState(
    docData.needsNonSmokingRoom || ""
  );

  // Pour les InputComponent
  const [passportStatus, setPassportStatus] = useState(
    docData.passportStatus || ""
  );
  const [currentPartner, setCurrentPartner] = useState(
    docData.currentPartner || ""
  );
  const [suicidalThoughtsWhen, setSuicidalThoughtsWhen] = useState(
    docData.suicidalThoughtsWhen || ""
  );
  const [suicidalThoughtsIntent, setSuicidalThoughtsIntent] = useState(
    docData.suicidalThoughtsIntent || ""
  );
  const [suicidePlan, setSuicidePlan] = useState(docData.suicidePlan || "");
  const [suicideAttemptsWhen, setSuicideAttemptsWhen] = useState(
    docData.suicideAttemptsWhen || ""
  );
  const [bodyHeight, setBodyHeight] = useState(docData.bodyHeight || "");

  // Pour les TextFieldComponentLarge
  const [currentLivingArrangements, setCurrentLivingArrangements] = useState(
    docData.currentLivingArrangements || ""
  );
  const [dietaryRequirements, setDietaryRequirements] = useState(
    docData.dietaryRequirements || ""
  );
  const [fundingSource, setFundingSource] = useState(
    docData.fundingSource || ""
  );
  const [currentWithdrawalSymptoms, setCurrentWithdrawalSymptoms] = useState(
    docData.currentWithdrawalSymptoms || ""
  );
  const [processAddictions, setProcessAddictions] = useState(
    docData.processAddictions || ""
  );
  const [addictionTreatmentHistory, setAddictionTreatmentHistory] = useState(
    docData.addictionTreatmentHistory || ""
  );
  const [treatmentGoals, setTreatmentGoals] = useState(
    docData.treatmentGoals || ""
  );
  const [barriersForRehab, setBarriersForRehab] = useState(
    docData.barriersForRehab || ""
  );
  const [motivationForTreatment, setMotivationForTreatment] = useState(
    docData.motivationForTreatment || ""
  );
  const [currentMentalHealthIssues, setCurrentMentalHealthIssues] = useState(
    docData.currentMentalHealthIssues || ""
  );
  const [lastSelfHarm, setLastSelfHarm] = useState(docData.lastSelfHarm || "");
  const [traumaHistory, setTraumaHistory] = useState(
    docData.traumaHistory || ""
  );
  const [currentProvider, setCurrentProvider] = useState(
    docData.currentProvider || ""
  );
  const [historyOfSeizures, setHistoryOfSeizures] = useState(
    docData.historyOfSeizures || ""
  );
  const [currentMedications, setCurrentMedications] = useState(
    docData.currentMedications || ""
  );
  const [currentPastInjury, setCurrentPastInjury] = useState(
    docData.currentPastInjury || ""
  );
  const [currentMedicalIllness, setCurrentMedicalIllness] = useState(
    docData.currentMedicalIllness || ""
  );
  const [allergies, setAllergies] = useState(docData.allergies || "");
  const [legalProblems, setLegalProblems] = useState(
    docData.legalProblems || ""
  );
  const [therapistPreference, setTherapistPreference] = useState(
    docData.therapistPreference || ""
  );
  const [discoverMiraclesAsia, setDiscoverMiraclesAsia] = useState(
    docData.discoverMiraclesAsia || ""
  );
  const [eatingDisorderDiagnosis, setEatingDisorderDiagnosis] = useState(
    docData.eatingDisorderDiagnosis || ""
  );
  const [eatingDisorderFoodConsumption, setEatingDisorderFoodConsumption] =
    useState(docData.eatingDisorderFoodConsumption || "");
  const [eatingDisorderVomitingLaxatives, setEatingDisorderVomitingLaxatives] =
    useState(docData.eatingDisorderVomitingLaxatives || "");
  const [traumaTreatment, setTraumaTreatment] = useState(
    docData.traumaTreatment || ""
  );

  const [historyPhysicalViolent, setHistoryPhysicalViolent] = useState(
    docData.historyPhysicalViolent || ""
  );
  const [mentalHealthTreatment, setMentalHealthTreatment] = useState(
    docData.mentalHealthTreatment || ""
  );
  const [selfHarmType, setSelfHarmType] = useState(docData.selfHarmType || "");
  const [unwantedConsequencesOfAddiction, setUnwantedConsequencesOfAddiction] =
    useState(docData.unwantedConsequencesOfAddiction || "");
  const [reasonForSeekingTreatment, setReasonForSeekingTreatment] = useState(
    docData.reasonForSeekingTreatment || ""
  );
  const [substanceAddiction, setSubstanceAddiction] = useState(
    docData.substanceAddiction || ""
  );
  const [childrenOrDependents, setChildrenOrDependents] = useState(
    docData.childrenOrDependents || ""
  );

  // Pour les Checkbox
  const [mentalHealthDiagnosis, setMentalHealthDiagnosis] = useState(
    docData.mentalHealthDiagnosis || false
  );
  const [anxiety, setAnxiety] = useState(docData.anxiety || false);
  const [depression, setDepression] = useState(docData.depression || false);
  const [ptsd, setPtsd] = useState(docData.ptsd || false);
  const [personalityDisorder, setPersonalityDisorder] = useState(
    docData.personalityDisorder || false
  );
  const [schizophrenia, setSchizophrenia] = useState(
    docData.schizophrenia || false
  );
  const [schizoaffectiveDisorder, setSchizoaffectiveDisorder] = useState(
    docData.schizoaffectiveDisorder || false
  );
  const [bipolar, setBipolar] = useState(docData.bipolar || false);
  const [bipolarWithPsychoticFeatures, setBipolarWithPsychoticFeatures] =
    useState(docData.bipolarWithPsychoticFeatures || false);
  const [previousPersonalityDisorder, setPreviousPersonalityDisorder] =
    useState(docData.previousPersonalityDisorder || false);

  const [bipolar12, setBipolar12] = useState(docData.bipolar12 || false);
  const [clientUnderstand, setClientUnderstand] = useState(
    docData.clientUnderstand || false
  );
  const [activePsychosis, setActivePsychosis] = useState(
    docData.activePsychosis || false
  );
  const [diagnosisWithPsychoticFeatures, setDiagnosisWithPsychoticFeatures] =
    useState(docData.diagnosisWithPsychoticFeatures || false);
  const [recentSelfHarm, setRecentSelfHarm] = useState(
    docData.recentSelfHarm || false
  );
  const [violentBehavior, setViolentBehavior] = useState(
    docData.violentBehavior || false
  );
  const [historyOfSeizure, setHistoryOfSeizure] = useState(
    docData.historyOfSeizure || false
  );
  const [activeFoodRestriction, setActiveFoodRestriction] = useState(
    docData.activeFoodRestriction || false
  );
  const [currentMobilityIssues, setCurrentMobilityIssues] = useState(
    docData.currentMobilityIssues || false
  );
  const [currentComplexMedicalIssues, setCurrentComplexMedicalIssues] =
    useState(docData.currentComplexMedicalIssues || false);

  const [suicidalIdeation, setSuicidalIdeation] = useState(
    docData.suicidalIdeation || false
  );

  const [suicideAttempt, setSuicideAttempt] = useState(
    docData.suicideAttempt || false
  );

  const [historyOfSuicideAttempts, setHistoryOfSuicideAttempts] = useState(
    docData.historyOfSuicideAttempts || false
  );
  const [suicidalThoughts, setSuicidalThoughts] = useState(
    docData.suicidalThoughts || false
  );

  const [hallucinations, setHallucinations] = useState(
    docData.hallucinations || false
  );

  const [hallucinationsExplain, setHallucinationsExplain] = useState(
    docData.hallucinationsExplain || ""
  );

  const [delusionalThinking, setDelusionalThinking] = useState(
    docData.delusionalThinking || false
  );

  const [delusionalThinkingExplain, setDelusionalThinkingExplain] = useState(
    docData.delusionalThinkingExplain || ""
  );

  const [flightDetails, setFlightDetails] = useState(
    docData.flightDetails || ""
  );
  const [vipTransfer, setVipTransfer] = useState(docData.vipTransfer || "");
  const [paymentDetails, setPaymentDetails] = useState(
    docData.paymentDetails || ""
  );

  const [assessmentStatus, setAssessmentStatus] = useState(
    docData.assessmentStatus || ""
  );

  const [assessmentReason, setAssessmentReason] = useState(
    docData.assessmentReason || ""
  );

  const [previousClientIdentifier, setPreviousClientIdentifier] = useState(
    docData.previousClientIdentifier || ""
  );

  // Handle functions

  const handleSpecificDisorderChange = (event) => {
    setSpecificDisorder(event.target.value);
  };

  const handleFlightDetailsContent = (event) => {
    setIsModified(true);
    setFlightDetailsContent(event);
  };

  const handleMentalHealthOtherCheck = (event) => {
    setIsModified(true);
    setMentalHealthOtherCheck(event.target.checked);
  };

  const handleMentalHealthOtherContent = (event) => {
    setIsModified(true);
    setMentalHealthOtherContent(event);
  };

  const handleHowLongUsingDring = (event) => {
    setIsModified(true);
    setHowLongUsingDrink(event);
  };

  const handleSuicideAttemptChange = (event) => {
    setSuicideAttempt(event.target.checked);
  };

  const handleSuicidalIdeationChange = (event) => {
    setIsModified(true);
    setSuicidalIdeation(event.target.checked);
  };

  const handleAssessmentReason = (value) => {
    setIsModified(true);
    setAssessmentReason(value);
  };

  const handlePreviousClientIdentifier = (value) => {
    setIsModified(true);
    setPreviousClientIdentifier(value);
  };

  const handleFlightDetailsChange = (value) => {
    setIsModified(true);
    setFlightDetails(value);
  };

  const handleVipTransferChange = (value) => {
    setIsModified(true);
    setVipTransfer(value);
  };
  const handlePaymentDetailsChange = (value) => {
    setIsModified(true);
    setPaymentDetails(value);
  };

  // Pour les DropDownComponent

  const handleAdhd = (event) => {
    setIsModified(true);
    setAdhd(event.target.checked);
  };

  const handleNoneApplyChange = (event) => {
    setIsModified(true);
    setNoneApply(event.target.checked);
  };

  const handleHallucinationsChange = (event) => {
    setIsModified(true);
    setHallucinations(event.target.value);
  };

  const handleHallucinationsExplainChange = (event) => {
    setIsModified(true);
    setHallucinationsExplain(event);
  };

  const handleDelusionalThinking = (event) => {
    setIsModified(true);
    setDelusionalThinking(event.target.value);
  };

  const handleDelusionalThinkingExplain = (event) => {
    setIsModified(true);
    setDelusionalThinkingExplain(event);
  };

  const handleNationalityChange = (event) => {
    setIsModified(true);
    setNationality(event);
  };

  const handleMaritalStatusChange = (event) => {
    setIsModified(true);
    setMaritalStatus(event);
  };

  const handlePassportCopy = (event) => {
    setIsModified(true);
    setPassportCopy(event);
  };

  const handlePrimaryAddictionChange = (event) => {
    setIsModified(true);
    setPrimaryAddiction(event);
  };

  const handleSecondaryAddictionChange = (event) => {
    setIsModified(true);
    setSecondaryAddiction(event);
  };

  const handleAssessmentStatus = (event) => {
    setIsModified(true);
    setAssessmentStatus(event);
  };

  // Pour les InputComponent
  const handleAddictionOther = (event) => {
    setIsModified(true);
    setAddictionOther(event);
  };

  const handleSecondaryAddictionOther = (event) => {
    setIsModified(true);
    setSecondaryAddictionOther(event);
  };

  const handlePassportStatusChange = (event) => {
    setIsModified(true);
    setPassportStatus(event);
  };

  const handlEtaChange = (event) => {
    setIsModified(true);
    setEta(event);
  };

  const handleCurrentPartnerChange = (event) => {
    setIsModified(true);
    setCurrentPartner(event);
  };

  const handleNeedsNonSmokingRoomChange = (val) => {
    setIsModified(true);
    setNeedsNonSmokingRoom(val);
  };

  const handleSuicidalThoughtsWhenChange = (event) => {
    setIsModified(true);
    setSuicidalThoughtsWhen(event);
  };

  const handleSuicidalThoughtsIntentChange = (event) => {
    setIsModified(true);
    setSuicidalThoughtsIntent(event);
  };

  const handleSuicidePlanChange = (event) => {
    setIsModified(true);
    setSuicidePlan(event);
  };

  const handleSuicideAttemptsWhenChange = (event) => {
    setIsModified(true);
    setSuicideAttemptsWhen(event);
  };

  const handleBodyHeightChange = (event) => {
    setIsModified(true);
    setBodyHeight(event);
  };

  // Pour les TextFieldComponentLarge

  const handleCurrentLivingArrangementsChange = (event) => {
    setIsModified(true);
    setCurrentLivingArrangements(event);
  };
  const handleDietaryRequirementsChange = (event) => {
    setIsModified(true);
    setDietaryRequirements(event);
  };
  const handleFundingSourceChange = (event) => {
    setIsModified(true);
    setFundingSource(event);
  };
  const handleCurrentWithdrawalSymptomsChange = (event) => {
    setIsModified(true);
    setCurrentWithdrawalSymptoms(event);
  };
  const handleProcessAddictionsChange = (event) => {
    setIsModified(true);
    setProcessAddictions(event);
  };
  const handleAddictionTreatmentHistoryChange = (event) => {
    setIsModified(true);
    setAddictionTreatmentHistory(event);
  };
  const handleTreatmentGoalsChange = (event) => {
    setIsModified(true);
    setTreatmentGoals(event);
  };
  const handleBarriersForRehabChange = (event) => {
    setIsModified(true);
    setBarriersForRehab(event);
  };
  const handleMotivationForTreatmentChange = (event) => {
    setIsModified(true);
    setMotivationForTreatment(event);
  };
  const handleCurrentMentalHealthIssuesChange = (event) => {
    setIsModified(true);
    setCurrentMentalHealthIssues(event);
  };
  const handleLastSelfHarmChange = (event) => {
    setIsModified(true);
    setLastSelfHarm(event);
  };
  const handleTraumaHistoryChange = (event) => {
    setIsModified(true);
    setTraumaHistory(event);
  };
  const handleCurrentProviderChange = (event) => {
    setIsModified(true);
    setCurrentProvider(event);
  };
  const handleHistoryOfSeizuresChange = (event) => {
    setIsModified(true);
    setHistoryOfSeizures(event);
  };
  const handleCurrentMedicationsChange = (event) => {
    setIsModified(true);
    setCurrentMedications(event);
  };
  const handleCurrentPastInjuryChange = (event) => {
    setIsModified(true);
    setCurrentPastInjury(event);
  };
  const handleCurrentMedicalIllnessChange = (event) => {
    setIsModified(true);
    setCurrentMedicalIllness(event);
  };
  const handleAllergiesChange = (event) => {
    setIsModified(true);
    setAllergies(event);
  };
  const handleLegalProblemsChange = (event) => {
    setIsModified(true);
    setLegalProblems(event);
  };
  const handleTherapistPreferenceChange = (event) => {
    setIsModified(true);
    setTherapistPreference(event);
  };

  const handleDiscoverMiraclesAsiaChange = (e) => {
    setIsModified(true);
    setDiscoverMiraclesAsia(e);
  };
  const handleEatingDisorderDiagnosisChange = (e) => {
    setIsModified(true);
    setEatingDisorderDiagnosis(e);
  };
  const handleEatingDisorderFoodConsumptionChange = (e) => {
    setIsModified(true);
    setEatingDisorderFoodConsumption(e);
  };
  const handleEatingDisorderVomitingLaxativesChange = (e) => {
    setIsModified(true);
    setEatingDisorderVomitingLaxatives(e);
  };
  const handleTraumaTreatmentChange = (e) => {
    setIsModified(true);
    setTraumaTreatment(e);
  };

  const handleHistoryPhysicalViolence = (e) => {
    setIsModified(true);
    setHistoryPhysicalViolent(e);
  };

  const handleMentalHealthTreatmentChange = (e) => {
    setIsModified(true);
    setMentalHealthTreatment(e);
  };
  const handleSelfHarmTypeChange = (e) => {
    setIsModified(true);
    setSelfHarmType(e);
  };
  const handleUnwantedConsequencesOfAddictionChange = (e) => {
    setIsModified(true);
    setUnwantedConsequencesOfAddiction(e);
  };
  const handleReasonForSeekingTreatmentChange = (e) => {
    setIsModified(true);
    setReasonForSeekingTreatment(e);
  };
  const handleSubstanceAddictionChange = (e) => {
    setIsModified(true);
    setSubstanceAddiction(e);
  };
  const handleChildrenOrDependentsChange = (e) => {
    setIsModified(true);
    setChildrenOrDependents(e);
  };

  // Checkbox

  const handleHistoryOfSuicideAttemptsChange = (event) => {
    setIsModified(true);
    setHistoryOfSuicideAttempts(event.target.value);
  };

  const handleSuicidalThoughtsChange = (event) => {
    setIsModified(true);
    setSuicidalThoughts(event.target.value);
  };

  const handlePreviousPersonalityDisorderChange = (event) => {
    setIsModified(true);
    setPreviousPersonalityDisorder(event.target.checked);
  };

  const handleBipolar12Change = (event) => {
    setIsModified(true);
    setBipolar12(event.target.checked);
  };

  const handleClientUnderstand = (event) => {
    setIsModified(true);
    setClientUnderstand(event.target.checked);
  };

  const handleActivePsychosisChange = (event) => {
    setIsModified(true);
    setActivePsychosis(event.target.checked);
  };

  const handleDiagnosisWithPsychoticFeaturesChange = (event) => {
    setIsModified(true);
    setDiagnosisWithPsychoticFeatures(event.target.checked);
  };

  const handleRecentSelfHarmChange = (event) => {
    setIsModified(true);
    setRecentSelfHarm(event.target.checked);
  };

  const handleViolentBehaviorChange = (event) => {
    setIsModified(true);
    setViolentBehavior(event.target.checked);
  };

  const handleHistoryOfSeizureChange = (event) => {
    setIsModified(true);
    setHistoryOfSeizure(event.target.checked);
  };

  const handleActiveFoodRestrictionChange = (event) => {
    setIsModified(true);
    setActiveFoodRestriction(event.target.checked);
  };

  const handleCurrentMobilityIssuesChange = (event) => {
    setIsModified(true);
    setCurrentMobilityIssues(event.target.checked);
  };

  const handleCurrentComplexMedicalIssuesChange = (event) => {
    setIsModified(true);
    setCurrentComplexMedicalIssues(event.target.checked);
  };

  const handleMentalHealthDiagnosisChange = (event) => {
    setIsModified(true);
    setMentalHealthDiagnosis(event.target.value);
  };

  const handleAnxietyChange = (event) => {
    setIsModified(true);
    setAnxiety(event.target.checked);
  };

  const handleDepressionChange = (event) => {
    setIsModified(true);
    setDepression(event.target.checked);
  };

  const handlePtsdChange = (event) => {
    setIsModified(true);
    setPtsd(event.target.checked);
  };

  const handlePersonalityDisorderChange = (event) => {
    setIsModified(true);
    setPersonalityDisorder(event.target.checked);
  };

  const handleSchizophreniaChange = (event) => {
    setIsModified(true);
    setSchizophrenia(event.target.checked);
  };

  const handleSchizoaffectiveDisorderChange = (event) => {
    setIsModified(true);
    setSchizoaffectiveDisorder(event.target.checked);
  };

  const handleBipolarChange = (event) => {
    setIsModified(true);
    setBipolar(event.target.checked);
  };

  const handleBipolarWithPsychoticFeaturesChange = (event) => {
    setIsModified(true);
    setBipolarWithPsychoticFeatures(event.target.value);
  };

  //FUNCTIONS

  async function saveToFirestore(clientId) {
    setIsLoading(true);

    try {
      const clientRef = doc(db, "clients", clientId);
      await setDoc(doc(db, "preAdmissionAssessments", clientId), {
        nationality,
        maritalStatus,
        primaryAddiction,
        secondaryAddiction,
        needsNonSmokingRoom,
        passportStatus,
        currentPartner,
        suicidalThoughtsWhen,
        suicidalThoughtsIntent,
        suicidePlan,
        suicideAttemptsWhen,
        bodyHeight,
        currentLivingArrangements,
        dietaryRequirements,
        fundingSource,
        currentWithdrawalSymptoms,
        processAddictions,
        addictionTreatmentHistory,
        treatmentGoals,
        barriersForRehab,
        motivationForTreatment,
        currentMentalHealthIssues,
        lastSelfHarm,
        traumaHistory,
        currentProvider,
        historyOfSeizures,
        currentMedications,
        currentPastInjury,
        currentMedicalIllness,
        allergies,
        legalProblems,
        therapistPreference,
        discoverMiraclesAsia,
        eatingDisorderDiagnosis,
        eatingDisorderFoodConsumption,
        eatingDisorderVomitingLaxatives,
        traumaTreatment,
        mentalHealthTreatment,
        selfHarmType,
        unwantedConsequencesOfAddiction,
        reasonForSeekingTreatment,
        substanceAddiction,
        childrenOrDependents,
        mentalHealthDiagnosis,
        anxiety,
        depression,
        ptsd,
        personalityDisorder,
        schizophrenia,
        schizoaffectiveDisorder,
        bipolar,
        bipolarWithPsychoticFeatures,
        previousPersonalityDisorder,
        activePsychosis,
        diagnosisWithPsychoticFeatures,
        recentSelfHarm,
        violentBehavior,
        historyOfSeizure,
        activeFoodRestriction,
        currentMobilityIssues,
        currentComplexMedicalIssues,
        historyOfSuicideAttempts,
        suicidalThoughts,
        recordedAt: serverTimestamp(),
        recordedBy: currentUser?.displayName,
        addictionOther,
        secondaryAddictionOther,
        hallucinations,
        delusionalThinking,
        hallucinationsExplain,
        delusionalThinkingExplain,
        noneApply,
        adhd,
        passportCopy,
        flightDetails,
        vipTransfer,
        paymentDetails,
        howLongUsingDrink,
        mentalHealthOtherCheck,
        mentalHealthOtherContent,
        flightDetailsContent,
        eta,
        suicidalIdeation,
        suicideAttempt,
        historyPhysicalViolent,
        assessmentStatus,
        assessmentReason,
        previousClientIdentifier,
        specificDisorder,
        bipolar12,
        clientUnderstand,
      });

      await updateDoc(clientRef, {
        nationality,
        maritalStatus,
        primaryAddiction,
        secondaryAddiction,
        addictionOther,
        secondaryAddictionOther,
        eta,
        durationOfStay,
      });

      const newData = {
        nationality,
        maritalStatus,
        primaryAddiction,
        secondaryAddiction,
        passportStatus,
        currentPartner,
        suicidalThoughtsWhen,
        suicidalThoughtsIntent,
        suicidePlan,
        suicideAttemptsWhen,
        bodyHeight,
        currentLivingArrangements,
        dietaryRequirements,
        fundingSource,
        currentWithdrawalSymptoms,
        processAddictions,
        addictionTreatmentHistory,
        treatmentGoals,
        barriersForRehab,
        motivationForTreatment,
        currentMentalHealthIssues,
        lastSelfHarm,
        traumaHistory,
        currentProvider,
        historyOfSeizures,
        currentMedications,
        currentPastInjury,
        currentMedicalIllness,
        allergies,
        legalProblems,
        therapistPreference,
        discoverMiraclesAsia,
        eatingDisorderDiagnosis,
        eatingDisorderFoodConsumption,
        eatingDisorderVomitingLaxatives,
        traumaTreatment,
        mentalHealthTreatment,
        selfHarmType,
        unwantedConsequencesOfAddiction,
        reasonForSeekingTreatment,
        substanceAddiction,
        childrenOrDependents,
        mentalHealthDiagnosis,
        anxiety,
        depression,
        ptsd,
        personalityDisorder,
        schizophrenia,
        schizoaffectiveDisorder,
        bipolar,
        bipolarWithPsychoticFeatures,
        previousPersonalityDisorder,
        activePsychosis,
        diagnosisWithPsychoticFeatures,
        recentSelfHarm,
        violentBehavior,
        historyOfSeizure,
        activeFoodRestriction,
        currentMobilityIssues,
        currentComplexMedicalIssues,
        historyOfSuicideAttempts,
        suicidalThoughts,
        recordedAt: serverTimestamp(),
        recordedBy: currentUser?.displayName,
        addictionOther,
        secondaryAddictionOther,
        hallucinations,
        delusionalThinking,
        hallucinationsExplain,
        delusionalThinkingExplain,
        noneApply,
        adhd,
        passportCopy,
        flightDetails,
        vipTransfer,
        paymentDetails,
        howLongUsingDrink,
        mentalHealthOtherCheck,
        mentalHealthOtherContent,
        flightDetailsContent,
        eta,
        suicidalIdeation,
        suicideAttempt,
        historyPhysicalViolent,
        assessmentStatus,
        assessmentReason,
        previousClientIdentifier,
        specificDisorder,
        bipolar12,
        durationOfStay,
        clientUnderstand,
      };

      const clientLogsRef = doc(
        collection(db, "logs", clientId, "modifications")
      );

      const logEntry = {
        clientId,
        changes: newData, // ou une sÃ©lection spÃ©cifique de newData si tout n'est pas pertinent
        recordedBy: currentUser?.displayName,
        recordedAt: serverTimestamp(),
      };
      await setDoc(clientLogsRef, logEntry);

      showCustomToast(
        "Pre admission document successfully recorded",
        "success"
      );
    } catch (error) {
      showCustomToast("Error recording Pre admission assessment", "error");
      console.error("Error adding document: ", error);
    } finally {
      setIsModified(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    props.onModificationChange(isModified);
  }, [isModified]);

  const [eta, setEta] = useState(docDataClient.eta || null);

  return (
    <div className="tab-container-white pre-admission-tab">
      <Modal
        open={openUploadPreAdmission}
        onClose={handleClosePreAdmForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalUploadPdf}>
          <UploaderPreAdmission {...props} closemodal={handleClosePreAdmForm} />
        </Box>
      </Modal>

      <div className="container-main-plan margin-bottom-2">
        <div className="tab-container-title">
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "10px",
                paddingLeft: "10px",
              }}
            >
              {/* PRE ADMISSION{" "} */}
              <button
                type="button"
                className="pre-admission-activity-button"
                aria-label="Open activity log"
                style={{
                  marginLeft: "0px",
                }}
                onClick={() => openModalLogs(props.clientId)}
              >
                <span className="pre-admission-activity-icon">↻</span>
                Activity Logs
                <span className="pre-admission-activity-count">{logs.length}</span>
              </button>
            </div>
            <span
              className="pre-admission-activity-meta"
            >
              {props.creatorName && props.dateOfCreation && (
                <div style={{ fontSize: "12px", fontStyle: "italic" }}>
                  {`Client added by ${
                    props.creatorName
                  } on ${props.dateOfCreation.toDate().toLocaleString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}`}
                </div>
              )}

              {/* {docData.recordedAt
              ? `( Last modifications done by ${
                  docData.recordedBy
                } on ${docData.recordedAt.toDate().toLocaleString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })})`
              : "No modifications done "} */}
            </span>
          </div>
          {isDetailsModalOpen && (
            <StandardDrawer
              open={isDetailsModalOpen}
              onClose={() => setIsDetailsModalOpen(false)}
              SlideProps={{ direction: "left" }}
            >
              <div className="standard-drawer-form-wrapper">
                <StandardDrawerHeader
                  eyebrow="PRE-ADMISSION"
                  title="Activity log details"
                  subtitle="Change history"
                  onClose={closeDetailLogsModal}
                />
                {selectedLog &&
                  showLogDetails(selectedLog, closeDetailLogsModal)}
                <StandardDrawerFooter>
                  <Button variant="contained" onClick={closeDetailLogsModal}>
                    Close
                  </Button>
                </StandardDrawerFooter>
              </div>
            </StandardDrawer>
          )}
          {isModalLogsOpen && (
            <StandardDrawer
              open={isModalLogsOpen}
              onClose={() => setIsModalLogsOpen(false)}
              SlideProps={{ direction: "left" }}
            >
              <div className="standard-drawer-form-wrapper">
                <StandardDrawerHeader
                  eyebrow="PRE-ADMISSION"
                  title="Activity logs"
                  subtitle={`${logs.length} recorded changes`}
                  onClose={closeLogsModal}
                />
                <div className="pre-admission-activity-body">
                  {logs
                    .sort(
                      (a, b) => b.recordedAt.toDate() - a.recordedAt.toDate()
                    )
                    .map((log) => (
                      <LineLogs
                        key={log.id}
                        log={log}
                        onDetailsClick={() => handleShowDetailsClick(log)}
                      />
                    ))}
                </div>
                <StandardDrawerFooter>
                  <Button variant="contained" onClick={closeLogsModal}>
                    Close
                  </Button>
                </StandardDrawerFooter>
              </div>
            </StandardDrawer>
          )}
        </div>

        {/* <div className="tab-form-container"></div> */}

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <AdmissionInformation
            eta={eta}
            handlEtaChange={handlEtaChange}
            durationOfStay={durationOfStay}
            handleDurationOfStayChange={handleDurationOfStayChange}
            needsNonSmokingRoom={needsNonSmokingRoom}
            handleNeedsNonSmokingRoomChange={handleNeedsNonSmokingRoomChange}
            passportStatus={passportStatus}
            handlePassportStatusChange={handlePassportStatusChange}
            passportCopy={passportCopy}
            handlePassportCopy={handlePassportCopy}
            previousClientIdentifier={previousClientIdentifier}
            handlePreviousClientIdentifier={handlePreviousClientIdentifier}
            flightDetails={flightDetails}
            handleFlightDetailsChange={handleFlightDetailsChange}
            flightDetailsContent={flightDetailsContent}
            handleFlightDetailsContent={handleFlightDetailsContent}
            vipTransfer={vipTransfer}
            handleVipTransferChange={handleVipTransferChange}
            paymentDetails={paymentDetails}
            handlePaymentDetailsChange={handlePaymentDetailsChange}
            nationality={nationality}
            handleNationalityChange={handleNationalityChange}
            maritalStatus={maritalStatus}
            handleMaritalStatusChange={handleMaritalStatusChange}
            currentPartner={currentPartner}
            handleCurrentPartnerChange={handleCurrentPartnerChange}
            requiresDurationOfStay={requiresDurationOfStay}
          />

          <div
            style={{ paddingLeft: "10px", width: "50%", paddingRight: "10px" }}
          >
            <div style={{ width: "100%" }}>
              <UploaderAraEncapsulated
                {...props}
                fileField="filesUrlPreAdm"
                storageFolder="PreAdmission"
                uploadTitle="Upload associated documents"
                uploadDescription="Add up to 3 files. Uploads start automatically after selection."
              />
            </div>
          </div>
        </div>

        <div className="pre-admission-additional-gap">
          <AdmissionAdditionalInfo
            childrenOrDependents={childrenOrDependents}
            handleChildrenOrDependentsChange={handleChildrenOrDependentsChange}
            currentLivingArrangements={currentLivingArrangements}
            handleCurrentLivingArrangementsChange={
              handleCurrentLivingArrangementsChange
            }
            dietaryRequirements={dietaryRequirements}
            handleDietaryRequirementsChange={handleDietaryRequirementsChange}
            fundingSource={fundingSource}
            handleFundingSourceChange={handleFundingSourceChange}
          />
        </div>
      </div>

      <AdmissionAddictions
        primaryAddiction={primaryAddiction}
        handlePrimaryAddictionChange={handlePrimaryAddictionChange}
        addictionOther={addictionOther}
        handleAddictionOther={handleAddictionOther}
        secondaryAddiction={secondaryAddiction}
        handleSecondaryAddictionChange={handleSecondaryAddictionChange}
        secondaryAddictionOther={secondaryAddictionOther}
        handleSecondaryAddictionOther={handleSecondaryAddictionOther}
        substanceAddiction={substanceAddiction}
        handleSubstanceAddictionChange={handleSubstanceAddictionChange}
        currentWithdrawalSymptoms={currentWithdrawalSymptoms}
        handleCurrentWithdrawalSymptomsChange={
          handleCurrentWithdrawalSymptomsChange
        }
        processAddictions={processAddictions}
        handleProcessAddictionsChange={handleProcessAddictionsChange}
        addictionTreatmentHistory={addictionTreatmentHistory}
        handleAddictionTreatmentHistoryChange={
          handleAddictionTreatmentHistoryChange
        }
        unwantedConsequencesOfAddiction={unwantedConsequencesOfAddiction}
        handleUnwantedConsequencesOfAddictionChange={
          handleUnwantedConsequencesOfAddictionChange
        }
        howLongUsingDrink={howLongUsingDrink}
        handleHowLongUsingDring={handleHowLongUsingDring}
        reasonForSeekingTreatment={reasonForSeekingTreatment}
        handleReasonForSeekingTreatmentChange={
          handleReasonForSeekingTreatmentChange
        }
        treatmentGoals={treatmentGoals}
        handleTreatmentGoalsChange={handleTreatmentGoalsChange}
        barriersForRehab={barriersForRehab}
        handleBarriersForRehabChange={handleBarriersForRehabChange}
        motivationForTreatment={motivationForTreatment}
        handleMotivationForTreatmentChange={handleMotivationForTreatmentChange}
      />

      <AdmissionMentalHealth
        mentalHealthDiagnosis={mentalHealthDiagnosis}
        handleMentalHealthDiagnosisChange={handleMentalHealthDiagnosisChange}
        anxiety={anxiety}
        handleAnxietyChange={handleAnxietyChange}
        depression={depression}
        handleDepressionChange={handleDepressionChange}
        ptsd={ptsd}
        handlePtsdChange={handlePtsdChange}
        personalityDisorder={personalityDisorder}
        handlePersonalityDisorderChange={handlePersonalityDisorderChange}
        specificDisorder={specificDisorder}
        handleSpecificDisorderChange={handleSpecificDisorderChange}
        schizophrenia={schizophrenia}
        handleSchizophreniaChange={handleSchizophreniaChange}
        schizoaffectiveDisorder={schizoaffectiveDisorder}
        handleSchizoaffectiveDisorderChange={handleSchizoaffectiveDisorderChange}
        bipolar={bipolar}
        handleBipolarChange={handleBipolarChange}
        adhd={adhd}
        handleAdhd={handleAdhd}
        mentalHealthOtherCheck={mentalHealthOtherCheck}
        handleMentalHealthOtherCheck={handleMentalHealthOtherCheck}
        mentalHealthOtherContent={mentalHealthOtherContent}
        handleMentalHealthOtherContent={handleMentalHealthOtherContent}
        bipolarWithPsychoticFeatures={bipolarWithPsychoticFeatures}
        handleBipolarWithPsychoticFeaturesChange={
          handleBipolarWithPsychoticFeaturesChange
        }
        hallucinations={hallucinations}
        handleHallucinationsChange={handleHallucinationsChange}
        hallucinationsExplain={hallucinationsExplain}
        handleHallucinationsExplainChange={handleHallucinationsExplainChange}
        delusionalThinking={delusionalThinking}
        handleDelusionalThinking={handleDelusionalThinking}
        delusionalThinkingExplain={delusionalThinkingExplain}
        handleDelusionalThinkingExplain={handleDelusionalThinkingExplain}
        currentMentalHealthIssues={currentMentalHealthIssues}
        handleCurrentMentalHealthIssuesChange={
          handleCurrentMentalHealthIssuesChange
        }
        suicidalThoughts={suicidalThoughts}
        handleSuicidalThoughtsChange={handleSuicidalThoughtsChange}
        suicidalThoughtsWhen={suicidalThoughtsWhen}
        handleSuicidalThoughtsWhenChange={handleSuicidalThoughtsWhenChange}
        suicidalThoughtsIntent={suicidalThoughtsIntent}
        handleSuicidalThoughtsIntentChange={handleSuicidalThoughtsIntentChange}
        suicidePlan={suicidePlan}
        handleSuicidePlanChange={handleSuicidePlanChange}
        historyOfSuicideAttempts={historyOfSuicideAttempts}
        handleHistoryOfSuicideAttemptsChange={
          handleHistoryOfSuicideAttemptsChange
        }
        suicideAttemptsWhen={suicideAttemptsWhen}
        handleSuicideAttemptsWhenChange={handleSuicideAttemptsWhenChange}
        selfHarmType={selfHarmType}
        handleSelfHarmTypeChange={handleSelfHarmTypeChange}
        lastSelfHarm={lastSelfHarm}
        handleLastSelfHarmChange={handleLastSelfHarmChange}
        traumaHistory={traumaHistory}
        handleTraumaHistoryChange={handleTraumaHistoryChange}
        traumaTreatment={traumaTreatment}
        handleTraumaTreatmentChange={handleTraumaTreatmentChange}
        historyPhysicalViolent={historyPhysicalViolent}
        handleHistoryPhysicalViolence={handleHistoryPhysicalViolence}
        mentalHealthTreatment={mentalHealthTreatment}
        handleMentalHealthTreatmentChange={handleMentalHealthTreatmentChange}
        currentProvider={currentProvider}
        handleCurrentProviderChange={handleCurrentProviderChange}
      />

      <AdmissionMedicalInfo
        historyOfSeizures={historyOfSeizures}
        handleHistoryOfSeizuresChange={handleHistoryOfSeizuresChange}
        currentMedications={currentMedications}
        handleCurrentMedicationsChange={handleCurrentMedicationsChange}
        currentPastInjury={currentPastInjury}
        handleCurrentPastInjuryChange={handleCurrentPastInjuryChange}
        currentMedicalIllness={currentMedicalIllness}
        handleCurrentMedicalIllnessChange={handleCurrentMedicalIllnessChange}
        allergies={allergies}
        handleAllergiesChange={handleAllergiesChange}
      />

      <AdmissionEatingDisorder
        eatingDisorderVomitingLaxatives={eatingDisorderVomitingLaxatives}
        handleEatingDisorderVomitingLaxativesChange={
          handleEatingDisorderVomitingLaxativesChange
        }
        eatingDisorderFoodConsumption={eatingDisorderFoodConsumption}
        handleEatingDisorderFoodConsumptionChange={
          handleEatingDisorderFoodConsumptionChange
        }
        bodyHeight={bodyHeight}
        handleBodyHeightChange={handleBodyHeightChange}
        eatingDisorderDiagnosis={eatingDisorderDiagnosis}
        handleEatingDisorderDiagnosisChange={handleEatingDisorderDiagnosisChange}
      />

      <AdmissionLegal
        legalProblems={legalProblems}
        handleLegalProblemsChange={handleLegalProblemsChange}
      />
      <AdmissionWrapUp
        discoverMiraclesAsia={discoverMiraclesAsia}
        handleDiscoverMiraclesAsiaChange={handleDiscoverMiraclesAsiaChange}
        therapistPreference={therapistPreference}
        handleTherapistPreferenceChange={handleTherapistPreferenceChange}
      />

      <AdmissionAssessorNotice
        clientUnderstand={clientUnderstand}
        handleClientUnderstand={handleClientUnderstand}
      />

      <AdmissionAssessorRedFlags
        bipolar12={bipolar12}
        handleBipolar12Change={handleBipolar12Change}
        previousPersonalityDisorder={previousPersonalityDisorder}
        handlePreviousPersonalityDisorderChange={handlePreviousPersonalityDisorderChange}
        activePsychosis={activePsychosis}
        handleActivePsychosisChange={handleActivePsychosisChange}
        diagnosisWithPsychoticFeatures={diagnosisWithPsychoticFeatures}
        handleDiagnosisWithPsychoticFeaturesChange={handleDiagnosisWithPsychoticFeaturesChange}
        recentSelfHarm={recentSelfHarm}
        handleRecentSelfHarmChange={handleRecentSelfHarmChange}
        violentBehavior={violentBehavior}
        handleViolentBehaviorChange={handleViolentBehaviorChange}
        historyOfSeizure={historyOfSeizure}
        handleHistoryOfSeizureChange={handleHistoryOfSeizureChange}
        activeFoodRestriction={activeFoodRestriction}
        handleActiveFoodRestrictionChange={handleActiveFoodRestrictionChange}
        currentMobilityIssues={currentMobilityIssues}
        handleCurrentMobilityIssuesChange={handleCurrentMobilityIssuesChange}
        currentComplexMedicalIssues={currentComplexMedicalIssues}
        handleCurrentComplexMedicalIssuesChange={handleCurrentComplexMedicalIssuesChange}
        suicidalIdeation={suicidalIdeation}
        handleSuicidalIdeationChange={handleSuicidalIdeationChange}
        suicideAttempt={suicideAttempt}
        handleSuicideAttemptChange={handleSuicideAttemptChange}
        noneApply={noneApply}
        handleNoneApplyChange={handleNoneApplyChange}
      />

      <AdmissionAssessmentOutcome
        assessmentStatus={assessmentStatus}
        handleAssessmentStatus={handleAssessmentStatus}
        assessmentReason={assessmentReason}
        handleAssessmentReason={handleAssessmentReason}
      />

      <div className="button-container-form-gi">
        <Button
          variant="contained"
          onClick={() => saveToFirestore(props.clientId)}
          style={
            isModified && !isLoading
              ? {
                  backgroundColor: "red",
                  color: "white",
                  marginLeft: "15px",
                }
              : {
                  backgroundColor: "#1565C0",
                  color: "white",
                  marginLeft: "15px",
                }
          }
          disabled={isLoading}
          sx={{
            height: "40px",
            width: "220px",
            marginLeft: "25px",
            marginRight: "30px",
          }}
        >
          {isLoading
            ? "SAVING MODIFICATIONS..."
            : isModified
            ? "CLICK TO SAVE"
            : "SAVE MODIFICATIONS"}
        </Button>
      </div>
    </div>
  );
}

export default PreAdmission;





